// Plan 1a Welle 2, Spur admin, Gruppe bereiche (spec-note-1/SPEC-ADMIN.md Ä-32 Punkt 1, Mechanik GB-02; welle-2/admin/
// AUFTEILUNG.md BE-9): Prüfung am Feld beim Verlassen und beim Absenden. Der Fehler steht über den Baustein Field (fehler) direkt
// am Feld. Reine Funktion; geprüft in frontend/tests/welle2-admin-bereiche.test.mjs („BE-9 …“).

/** Derselbe Wortlaut wie im Fenster „Organisation anlegen“ der Verwaltung (forms.tsx EMAIL_FEHLER, Ä-24): ein Satz für jedes
 *  E-Mail-Feld. Er steht hier ein zweites Mal, damit „Firmendaten“ das große Formularmodul nicht lädt; die Prüfung hält beide
 *  Sätze gleich. */
export const EMAIL_FEHLER = 'Bitte eine vollständige E-Mail-Adresse eintragen, etwa name@firma.at.';
/** Leer ist kein Fehler (das Feld ist freiwillig); sonst braucht die Adresse ein „@“ und dahinter einen Punkt. Anmeldeprobe
 *  Schlusslauf 5: wie forms.tsx emailFehler kein Punkt am Ende und keine zwei Punkte hintereinander nach dem „@“. */
export const emailFehler = (text: string): string | undefined => {
  const wert = text.trim();
  return !wert || /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(wert) ? undefined : EMAIL_FEHLER;
};

/** Fehler am Feld „Name der Organisation“ (Wortlaut im Bau festgelegt): der Name braucht ohne Leerzeichen am Rand mindestens
 *  zwei Zeichen, wie am Server (backend/src/administration/organization/company.ts firmenName). */
export const FIRMENNAME_FEHLT = 'Bitte einen Namen mit mindestens 2 Zeichen eintragen.';
export const firmennameFehler = (name: string): string | undefined => name.trim().length >= 2 ? undefined : FIRMENNAME_FEHLT;

/** Profil-Nachbau F-12 Punkt 7 (SPEC-WELLE-A WA-07, PF-716): das Telefon eines Schlüsselkontakts – leer oder mit Ländervorwahl,
 *  dieselbe Regel und derselbe Satz wie am Server (backend/src/administration/organization/contacts.ts TELEFON, KONTAKT_SAETZE). */
export const TELEFON_FEHLER = 'Bitte mit Ländervorwahl eingeben, etwa +43 512 123456.';
export const telefonFehler = (text: string): string | undefined => {
  const wert = text.trim();
  return !wert || /^\+[1-9][0-9 /-]{5,24}$/.test(wert) ? undefined : TELEFON_FEHLER;
};
